import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { LoadingModule } from 'ngx-loading';
import { InputView } from 'app/views/input/input.component';
import { FormCompnentModule } from 'app/components/form/form.module';
import { CommonModule } from '@angular/common';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        LoadingModule,
        FormCompnentModule
    ],
    declarations: [InputView],
    providers: [],
    exports: [InputView]
})
export class InputViewModule { }



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/input/input.module.ts